import { UserUtils, userStore } from "@/stores/UserStore";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

export interface FormAddNewUser {
  login: string;
  password: string;
  role: number;
  fio: string;
  active: boolean;
}

export const useFormAddNewUser = (userData: UserUtils) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormAddNewUser>({
    defaultValues: {
      login: "",
      password: "",
      role: userStore.role || 1,
      fio: "",
      active: false,
    },
    mode: "onSubmit",
  });

  const defaultValues = (scope: "full" | "part") => {
    if (scope === "full") {
      setValue("login", "");
      setValue("password", "");
      setValue("role", 0);
      setValue("fio", "");
      setValue("active", false);
    }
  };

  const setRole = (value: number | string) => {
    setValue("role", value as number);
  };

  const setActive = (value: boolean) => {
    setValue("active", value);
  };

  const onSubmit = (data: FormAddNewUser) => {
    console.log(data);

    userData.setNewDataAutenticatedUser(data);
    defaultValues("part");
  };

  useEffect(() => {
    return () => {
      defaultValues("full");
    };
    // eslint-disable-next-line
  }, []);

  return {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    defaultValues,
    setRole,
    setActive,
    onSubmit,
  };
};
